export default __webpack_public_path__ + "static/media/polaroid20.22593416.jpg";